import React, { useEffect, useState } from 'react';
import Checkbox from '../../../Components/Base/Checkbox/Checkbox';
// @ts-ignore
import styles from './MarkFileAsPrintedOut.module.scss';
import apiClient from '../../../Services/ApiClient';
import useApiClient from '../../Base/Hooks/useApiClient';
import { markFileAsPrinted } from '../Services/files.service';

interface Props {
	fileId: string;
	patientId: string;
	printed: boolean;
}

const MarkFileAsPrintedOut: React.FC<Props> = ({
	fileId,
	printed,
	patientId,
}) => {
	const { displayError } = useApiClient();
	const [checked, setChecked] = useState(printed);
	const handleChange = async () => {
		setChecked(prev => !prev);
		try {
			await markFileAsPrinted(patientId, fileId, !checked);
		} catch (e: any) {
			displayError(e);
		}
	};

	useEffect(() => {
		if (printed !== checked) {
			setChecked(printed);
		}
	}, [printed]);

	return (
		<Checkbox
			tx='base.printedOut'
			value={checked}
			onChange={handleChange}
			checkClassName={styles.check}
			titleClassName={styles.title}
		/>
	);
};

export default MarkFileAsPrintedOut;
